/* eslint-disable */
const getters = {
  getTags(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
